import React from "react";
import { Hotspot, Popup, TourData, question } from "../../../../../Types";
import { Interactive, useController } from "@react-three/xr";
import XROpenQuiz from "../Open/XROpenQuiz";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { useGetQuiz } from "../../../../../api/calls/Quiz";
import { useCursorShrinkingStore } from "../../UI/CursorNew";
import { useXRPopupStore } from "../XRHotspots";
import { useDataRootStore } from "../../../../../api/Zustand";
import { IconFromSvg } from "./XRPopup";
import XROpenPopup from "../Open/XROpenPopup";
import { text } from "stream/consumers";

let timeout: NodeJS.Timeout;
let timeout2: NodeJS.Timeout;

const XRQuiz = (props: {
  tourID: number;
  userID: number;
  pos: THREE.Vector3;
  hs: Hotspot;
  tourData: TourData;
}) => {
  const { data: quizData } = useGetQuiz(
    props.tourID,
    props.tourData.assignedQuizID
  );

  const iconRef = React.useRef<THREE.Group>(null);

  const gaze = useController("none");

  const [hovered, isHovered] = React.useState<boolean>(false);

  useFrame(() => {
    if (iconRef.current) {
      if (hovered) {
        iconRef.current.scale.lerp(new THREE.Vector3(1.2, 1.2, 1.2), 0.1);
      } else iconRef.current.scale.lerp(new THREE.Vector3(1, 1, 1), 0.1);
    }
  });

  const question: question | undefined = React.useMemo(() => {
    return quizData?.data.find((one) => one.questionId === props.hs.target);
  }, [quizData?.data, props.hs]);

  const { root } = useDataRootStore();

  const cursor = useCursorShrinkingStore();

  const xrPop = useXRPopupStore();

  const questionInPopupFormat: Popup | undefined = React.useMemo(() => {
    if (question) {
      const generatedPop: Popup = {
        id: question?.questionId,
        title: question.questionText,
        imageID: question.questionMaterialeGenericoId,
        type: question.questionImgKey ? "image" : "text",
        image: undefined,
        text: undefined,
        media: undefined,
        video: undefined,
        imageName: undefined,
      };

      return generatedPop;
    }
  }, [question]);

  if (root)
    return (
      <>
        {!xrPop.isOpen && (
          <group
            scale={gaze ? 1 : 0.6}
            onUpdate={(self) => self.lookAt(0, 0, 0)}
            position={props.pos}
            visible={!xrPop.isOpen}
          >
            <group>
              <Interactive
                onSelect={(e) => {
                  xrPop.openPop(
                    props.hs.id as string,
                    e.intersection?.point.normalize().multiplyScalar(3)!
                  );
                }}
                onHover={(e) => {
                  isHovered(true);
                  if (gaze) {
                    timeout = setTimeout(() => {
                      cursor.setShrinking(true);
                      timeout2 = setTimeout(() => {
                        xrPop.openPop(
                          props.hs.id as string,
                          e.intersection?.point.normalize().multiplyScalar(3)!
                        );
                      }, 2e3);
                    }, 1e3);
                  }
                }}
                onBlur={() => {
                  isHovered(false);
                  clearTimeout(timeout);
                  clearTimeout(timeout2);
                  cursor.setShrinking(false);
                }}
              >
                <IconFromSvg
                  iconRef={iconRef}
                  url={root + "/svg/quizicon.svg"}
                />

                <mesh renderOrder={6} name="hotspot" visible={false}>
                  <planeGeometry args={[20, 20]} />
                  <meshBasicMaterial wireframe />
                </mesh>
              </Interactive>
            </group>
          </group>
        )}

        {question && questionInPopupFormat && xrPop.target === props.hs.id && (
          // <XROpenPopup hs={props.hs} pop={questionInPopupFormat}></XROpenPopup>
          <XROpenQuiz
            hs={props.hs}
            question={question}
            tourID={props.tourID}
            userID={props.userID}
          />
        )}
      </>
    );
};

export default XRQuiz;
